import { render, staticRenderFns } from "./a-input-search.vue?vue&type=template&id=08a2f075&scoped=true"
import script from "./a-input-search.vue?vue&type=script&lang=js"
export * from "./a-input-search.vue?vue&type=script&lang=js"
import style0 from "./a-input-search.vue?vue&type=style&index=0&id=08a2f075&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a2f075",
  null
  
)

export default component.exports